<template>
  <div class="info">
  <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm" size="small">
    <el-form-item :label="$t('user.password.oldPassword')" prop="oldpassword">
      <el-input type="password" v-model="ruleForm.oldpassword" autocomplete="off" :placeholder="$t('user.password.placeholder.inputOldPassword')"></el-input>
    </el-form-item>
    <el-form-item :label="$t('user.password.newPassword')" prop="newpassword">
      <el-input type="password" v-model="ruleForm.newpassword" autocomplete="off" :placeholder="$t('user.password.placeholder.inputNewPassword')"></el-input>
    </el-form-item>
    <el-form-item :label="$t('user.password.confirmPassword')" prop="checkPass">
      <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" :placeholder="$t('user.password.placeholder.inputConfirmPassword')"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitForm('ruleForm')">{{ $t('user.password.submit') }}</el-button>
      <el-button @click="resetForm('ruleForm')">{{ $t('user.password.reset') }}</el-button>
    </el-form-item>
  </el-form>
  </div>
</template>

<script>
  import { passEdit } from '@/api/user'
  export default {
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('user.password.requiredMessage.newPassword')));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('user.password.requiredMessage.reEnterPassword')));
        } else if (value !== this.ruleForm.newpassword) {
          callback(new Error(this.$t('user.password.requiredMessage.passwordNotMatch')));
        } else {
          callback();
        }
      };
      return {
        ruleForm: {
          oldpassword: '',
          newpassword: '',
          checkPass: '',
        },
        rules: {
          oldpassword: [
            {required: true, message: this.$t('user.password.requiredMessage.oldPassword'), trigger: 'blur' }
          ],
          newpassword: [
            {required: true, validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            {required: true, validator: validatePass2, trigger: 'blur' }
          ]
        }
      };
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let form = {
              ...this.ruleForm,
              user_code:JSON.parse(window.localStorage.getItem("userInfo1")).user_code
            }
            
            passEdit(form).then(res => {
              if(res.code == 1){
                this.resetForm(formName)
                this.$message.success(res.msg)
              }else{
                this.$message.error(res.msg)
              }
            })
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>
<style lang="scss" scoped>
  .info{
    background: #fff;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    .demo-ruleForm{
      width: 50%;
    }
  }
</style>